<template>
  <div class="top-div">
    <feather-icon
      icon="ArrowLeftIcon"
      class="back-icon"
      svgClasses="text-dark"
      @click="clickOnBack"
    />
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
  methods: {
    clickOnBack() {
      this.$emit("backPress");
    },
  },
};
</script>

<style>
.top-div {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.top-div p {
  font-size: 20px;
  font-weight: 500;
}
.back-icon {
  cursor: pointer;
}
</style>
